import { Order, State } from 'entities/orders/model/types';

const defaultOrderStateValues = {
	isVisitProgress: false,
	isVisitDelay: false,
	isVisitWaiting: false,
	isVisitEnd: false,
	isOrderExists: false,
	isWaitingList: false,
	isCanceled: false,
	isVisitMissed: false,
};

export const useOrderState = (order?: Order | null) => {
	if (!order) {
		return defaultOrderStateValues;
	}

	const isVisitDelay = order.state === State.DELAY;
	const isVisitStart = Boolean(order.appointment?.dt_visit_start);
	const isVisitEnd = Boolean(order.appointment?.dt_visit_end);
	const isVisitWaiting = order.state === State.WAITING;
	let isVisitProgress = false;
	let isOrderExists = false;
	let isWaitingList = false;
	const isCanceled = order.status === 'cancelled';
	const isVisitMissed = order.status === 'visit_missed';

	if (
		(isVisitStart && !order.state && !isVisitEnd) ||
		order.state === State.ENDING ||
		order.state === State.EXCEEDING ||
		order.state === State.BUSY
	) {
		isVisitProgress = true;
	}

	if (
		!isVisitStart &&
		!order.state &&
		!isVisitEnd &&
		order.status === 'appointed'
	) {
		isOrderExists = true;
	}

	if (order.status === 'waiting_list' && !order.state) {
		isWaitingList = true;
	}

	return {
		isVisitProgress,
		isVisitDelay,
		isVisitWaiting,
		isVisitEnd,
		isOrderExists,
		isWaitingList,
		isCanceled,
		isVisitMissed,
	};
};
